import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getThemeTokens } from '../tokens';

export const styledBackstageTableToolbar = (
  theme: Theme,
): BackstageOverrides['BackstageTableToolbar'] => {
  const tokens = getThemeTokens(theme);

  return {
    root: {
      padding: theme.spacing(1.75, 2),
    },
    title: {
      color: tokens.textPrimary,
      fontSize: theme.typography.subtitle1.fontSize,
      fontWeight: 700,
      '& h2': {
        color: tokens.textPrimary,
        fontSize: theme.typography.h6.fontSize,
        fontWeight: 700,
        lineHeight: theme.typography.h6.lineHeight,
        margin: 0,
      },
    },
    searchField: {
      minWidth: theme.spacing(30),
    },
  };
};
